import styled from 'styled-components';
import TableContainer from '@mui/material/TableContainer';
import CustomButton from '../../components/Form/Button';
import { FormWrapper, OrangeAccentCard } from '../../styles/listPageTheme';

/* full-bleed no container-fluid (padding 1.5rem) + evita faixa clara à direita (overflow flex) */
export const TradingWrapper = styled.div`
  background: #0a0e27;
  position: relative;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-self: stretch;
  width: calc(100% + 3rem);
  max-width: none;
  box-sizing: border-box;
  min-width: 0;
  min-height: calc(100vh - 4.375rem);
  margin: calc(-24px - 1.5rem - 4.375rem) -1.5rem 0 -1.5rem;
  padding-top: calc(4.375rem + 1.5rem);
  padding-bottom: 2rem;
`;

export const ContentArea = styled.div`
  position: relative;
  z-index: 1;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  padding: 24px 16px 48px 16px;

  @media (min-width: 768px) {
    padding: 24px 24px 48px 24px;
  }

  @media (min-width: 1200px) {
    padding: 24px 48px 48px 48px;
  }
`;

export const PageHeader = styled.div`
  position: relative;
  z-index: 1;
  padding: 16px 0 0 0;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;

  @media (min-width: 768px) {
    padding: 24px 0 0 0;
    margin-bottom: 32px;
  }

  h1 {
    color: #ffffff;
    font-size: 24px;
    font-weight: 700;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);

    @media (min-width: 768px) {
      font-size: 32px;
      gap: 12px;
    }

    i {
      color: #f29205;
      font-size: 28px;
      text-shadow: 0 0 10px rgba(242, 146, 5, 0.5);

      @media (min-width: 768px) {
        font-size: 36px;
      }
    }

    .badge {
      background: linear-gradient(135deg, #f29205 0%, #ff6b35 100%);
      color: #ffffff;
      padding: 4px 10px;
      border-radius: 20px;
      font-size: 14px;
      font-weight: 700;
      margin-left: 8px;
      box-shadow: 0 2px 8px rgba(242, 146, 5, 0.3);

      @media (min-width: 768px) {
        padding: 6px 12px;
        font-size: 16px;
        margin-left: 12px;
      }
    }
  }
`;

/** Listagem /trading: mesmo espaçamento que /bank/movements e /estrategias */
export const TradingListPageHeader = styled(PageHeader)`
  z-index: 2;
  margin-bottom: 28px;

  @media (min-width: 768px) {
    margin-bottom: 36px;
  }
`;

export const TradingBelowHeaderSection = styled.div`
  width: 100%;
  position: relative;
  z-index: 2;
  margin-top: 16px;

  @media (min-width: 576px) {
    margin-top: 20px;
  }

  @media (min-width: 992px) {
    margin-top: 24px;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
`;

export const NewTradingButton = styled.a`
  box-sizing: border-box;
  background: linear-gradient(135deg, #f29205 0%, #ff6b35 100%);
  color: #ffffff !important;
  padding: 10px 20px;
  border-radius: 999px;
  font-weight: 600;
  text-decoration: none !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  box-shadow: 0 4px 15px rgba(242, 146, 5, 0.3);
  transition: all 0.3s ease;
  font-size: 14px;
  line-height: 1.2;
  min-height: 44px;
  height: 44px;
  border: none;
  cursor: pointer;
  white-space: nowrap;

  @media (min-width: 768px) {
    padding: 12px 24px;
    gap: 8px;
    font-size: 16px;
    min-height: 48px;
    height: auto;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(242, 146, 5, 0.4);
    color: #ffffff !important;
    text-decoration: none !important;
  }
`;

/** Estilo escuro do header (Pares de moedas, Importar CSV) */
export const CurrencyPairButton = styled(NewTradingButton)`
  background: linear-gradient(135deg, rgba(10, 14, 39, 0.95) 0%, rgba(22, 33, 62, 0.98) 100%);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35), 0 0 0 1px rgba(0, 0, 0, 0.2);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);

  &:hover {
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.45), 0 0 16px rgba(242, 146, 5, 0.25);
    color: #ffffff !important;
  }
`;

export const TradingCard = styled(OrangeAccentCard)`
  position: relative;
  z-index: 1;
`;

export const MetaDashboard = styled.div`
  position: relative;
  z-index: 1;
  margin-bottom: 24px;
`;

/** Mesma pegada de “Resumo do período” em /bank/movements */
export const PeriodSummarySection = styled.div`
  padding: 4px 16px 8px;

  @media (min-width: 768px) {
    padding: 4px 32px 12px;
  }
`;

export const PeriodSummaryHeading = styled.div`
  color: #f29205;
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 10px;
  text-shadow: 0 0 10px rgba(242, 146, 5, 0.25);

  i {
    color: #ff6b35;
    font-size: 18px;
  }

  @media (min-width: 768px) {
    font-size: 17px;
    margin-bottom: 18px;

    i {
      font-size: 20px;
    }
  }
`;

export const PeriodSummaryGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;

  @media (min-width: 600px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }
`;

export const PeriodSummaryCard = styled.div`
  position: relative;
  border-radius: 16px;
  padding: 18px 16px 20px;
  background: linear-gradient(155deg, rgba(18, 22, 46, 0.98) 0%, rgba(26, 32, 58, 0.94) 100%);
  border: 1px solid ${(p) => p.$border};
  box-shadow:
    0 10px 28px rgba(0, 0, 0, 0.38),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, transparent, ${(p) => p.$line}, transparent);
    opacity: 0.95;
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow:
      0 16px 40px rgba(0, 0, 0, 0.48),
      0 0 36px ${(p) => p.$glow};
    border-color: ${(p) => p.$borderHover};
  }
`;

export const PeriodSummaryIconWrap = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
  font-size: 21px;
  background: ${(p) => p.$bg};
  color: ${(p) => p.$fg};
  box-shadow: 0 4px 16px ${(p) => p.$shadow};
`;

export const PeriodSummaryLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #9aa3c4;
  line-height: 1.4;
  margin-bottom: 10px;
  min-height: 2.8em;
  display: flex;
  align-items: flex-end;
`;

export const PeriodSummaryValue = styled.div`
  font-size: clamp(1.05rem, 2.8vw, 1.55rem);
  font-weight: 800;
  color: ${(p) => p.$c};
  line-height: 1.25;
  word-break: break-word;
`;

/** Conteúdo extra abaixo do valor (formulário, lista, progresso) */
export const PeriodSummaryExtras = styled.div`
  width: 100%;
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
`;

/** Barra de progresso da meta diária */
export const MetaProgressBlock = styled.div`
  width: 100%;
  margin: 4px 0 14px;
`;

export const MetaProgressLabel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(160, 170, 200, 0.85);
`;

export const MetaProgressTrack = styled.div`
  height: 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.06);
  overflow: hidden;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.35);
`;

export const MetaProgressFill = styled.div`
  height: 100%;
  width: ${(p) => Math.min(100, Math.max(0, p.$pct || 0))}%;
  border-radius: 999px;
  background: linear-gradient(
    90deg,
    rgba(74, 222, 128, 0.85) 0%,
    #4ade80 45%,
    rgba(242, 146, 5, 0.95) 100%
  );
  box-shadow: 0 0 12px rgba(74, 222, 128, 0.35);
  transition: width 0.45s ease-out;
`;

export const MetaPayoutFieldWrap = styled.div`
  width: 100%;
  max-width: 260px;
  margin: 0 auto 12px;

  .MuiFormControl-root {
    width: 100%;
  }
`;

export const MetaMuted = styled.p`
  color: #b0b0b0;
  font-size: 13px;
  margin: 0;
  line-height: 1.5;
`;

/** Lista de sugestões centralizada (antes ficava só à esquerda) */
export const MetaSuggestionsList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 6px;

  ${MetaMuted} {
    text-align: center;
    width: 100%;
    max-width: 100%;
    padding: 8px 12px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.035);
    border: 1px solid rgba(255, 255, 255, 0.06);
    font-size: 12.5px;
    transition: background 0.2s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.055);
    }
  }
`;

export const FilterSection = styled.div`
  padding: 20px 16px;

  @media (min-width: 768px) {
    padding: 32px;
  }
`;

export const FilterTitle = styled.div`
  color: #f29205;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  text-shadow: 0 0 10px rgba(242, 146, 5, 0.3);

  @media (min-width: 768px) {
    font-size: 18px;
    margin-bottom: 20px;
    gap: 10px;
  }

  i {
    font-size: 18px;
    color: #ff6b35;
    filter: drop-shadow(0 0 5px rgba(255, 107, 53, 0.5));

    @media (min-width: 768px) {
      font-size: 20px;
    }
  }
`;

export const StyledFilterFormWrapper = styled(FormWrapper)`
  /* Mesma “caixa” visual entre TextField (datas) e Select: sem margem extra */
  .MuiFormControl-root {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  @media (max-width: 767px) {
    .MuiFormControl-root .MuiOutlinedInput-root {
      height: 48px !important;
      min-height: 48px !important;

      .MuiInputBase-input {
        height: 48px !important;
        padding: 12px 14px !important;
        font-size: 14px !important;
      }
    }
  }
`;

export const FilterRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: stretch;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: flex-end;
    flex-wrap: wrap;
  }
`;

export const FilterField = styled.div`
  flex: 1;
  min-width: 0;
  width: 100%;

  .MuiFormControl-root {
    width: 100%;
  }

  @media (min-width: 768px) {
    flex: 1 1 220px;
    max-width: 320px;
    width: auto;
  }
`;

export const FilterButtonWrap = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;
  width: 100%;
  align-self: stretch;

  /* Mesma altura dos btns do header (CurrencyPairButton / NewTradingButton): 44px no mobile */
  .MuiButton-root {
    width: 100% !important;
    max-width: 100%;
    justify-content: center;
    min-height: 44px !important;
    height: 44px !important;
    padding: 10px 18px !important;
    font-size: 14px !important;
    line-height: 1.25 !important;
    border-radius: 999px !important;
    box-sizing: border-box !important;
  }

  .MuiButton-label {
    gap: 6px;
  }

  @media (min-width: 768px) {
    width: auto;
    align-self: flex-end;
    justify-content: flex-start;

    .MuiButton-root {
      width: auto !important;
      max-width: none;
      min-height: 52px !important;
      height: 52px !important;
      padding: 0 22px !important;
      font-size: 14px !important;
    }
  }

  @media (min-width: 992px) {
    .MuiButton-root {
      min-height: 56px !important;
      height: 56px !important;
      padding: 0 28px !important;
      font-size: 15px !important;
    }
  }
`;

export const StyledTableContainer = styled(TableContainer)`
  background: rgba(255, 255, 255, 0.05) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(242, 146, 5, 0.2) !important;
  overflow-x: auto !important;
  -webkit-overflow-scrolling: touch !important;

  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(242, 146, 5, 0.5);
    border-radius: 4px;

    &:hover {
      background: rgba(242, 146, 5, 0.7);
    }
  }

  .MuiTable-root {
    background: transparent !important;
    min-width: 650px !important;
  }

  .MuiTableHead-root {
    background: rgba(242, 146, 5, 0.1) !important;

    .MuiTableCell-head {
      color: #f29205 !important;
      font-weight: 700 !important;
      border-bottom: 2px solid rgba(242, 146, 5, 0.3) !important;
      padding: 12px 8px !important;
      white-space: nowrap !important;

      @media (min-width: 768px) {
        padding: 16px !important;
      }
    }
  }

  .MuiTableBody-root .MuiTableRow-root {
    transition: all 0.2s ease !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;

    &:hover {
      background: rgba(242, 146, 5, 0.05) !important;
    }

    .MuiTableCell-body {
      color: #e0e0e0 !important;
      padding: 12px 8px !important;
      border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;

      @media (min-width: 768px) {
        padding: 16px !important;
      }
    }
  }

  .MuiTableFooter-root {
    background: rgba(242, 146, 5, 0.05) !important;

    .MuiTableCell-footer {
      border-top: 2px solid rgba(242, 146, 5, 0.3) !important;
      padding: 12px 8px !important;

      @media (min-width: 768px) {
        padding: 16px !important;
      }
    }
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;

  .MuiIconButton-root {
    color: #00d4ff !important;
    transition: all 0.2s ease !important;

    &:hover {
      background: rgba(0, 212, 255, 0.1) !important;
      transform: scale(1.1);
    }

    &[aria-label='delete'] {
      color: #ff6b6b !important;

      &:hover {
        background: rgba(255, 107, 107, 0.1) !important;
      }
    }
  }
`;

export const PaginationInfo = styled.span`
  color: #b0b0b0;
  font-size: 14px;
  padding: 12px 16px;
  display: inline-block;
`;

export const PaginationButton = styled.button`
  background: rgba(255, 255, 255, 0.05);
  border: 2px solid rgba(255, 255, 255, 0.1);
  color: #e0e0e0;
  padding: 10px 20px;
  border-radius: 999px;
  font-weight: 600;
  transition: all 0.3s ease;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &:hover:not(:disabled) {
    background: rgba(242, 146, 5, 0.1);
    border-color: rgba(242, 146, 5, 0.3);
    color: #f29205;
    transform: translateY(-2px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const LoadingButton = styled(CustomButton)`
  width: 100%;
  background: rgba(255, 255, 255, 0.05) !important;
  border: 2px solid rgba(255, 255, 255, 0.1) !important;
  color: #e0e0e0 !important;
`;

export const EmptyState = styled.div`
  padding: 32px;

  .MuiAlert-root {
    background: rgba(242, 146, 5, 0.1) !important;
    border: 1px solid rgba(242, 146, 5, 0.3) !important;
    color: #f29205 !important;
    border-radius: 12px !important;
  }
`;

export const TableWrapper = styled.div`
  padding: 16px;
  padding-top: 0;

  @media (min-width: 768px) {
    padding: 32px;
    padding-top: 0;
  }
`;

export const ResultBadge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
`;
